import * as React from "react";
import { ElasticSlider } from "@aisquare/ui";
import { Sun, Moon } from "lucide-react";
import { Section, VariantBlock } from "../lib/Section";

export function ElasticSliderDemo() {
  // Controlled example so the live value reads out next to the control.
  const [value, setValue] = React.useState(60);

  return (
    <Section
      id="elastic-slider"
      title="ElasticSlider"
      description="The canonical single-value slider primitive. A custom track flanked by icons and a numeric readout: drag PAST either end and the whole track stretches elastically (the over-drag saturates, the end icon nudges out and pulses), then springs back on release. Single-value scalar API. Full keyboard + role=slider ARIA support. The elastic stretch, spring-back, and hover swell all collapse under prefers-reduced-motion, while the control stays fully draggable and accurate."
    >
      <VariantBlock label="Default" caption="uncontrolled, 0–100 — drag past the end to feel the stretch">
        <div className="w-80">
          <ElasticSlider defaultValue={50} min={0} max={100} />
        </div>
      </VariantBlock>

      <VariantBlock label="Controlled" caption="scalar value/onValueChange — the value is reported as a number, not an array">
        <div className="flex w-80 flex-col gap-2">
          <ElasticSlider value={value} min={0} max={100} onValueChange={setValue} />
          <span className="text-xs text-muted-foreground">value: {value}</span>
        </div>
      </VariantBlock>

      <VariantBlock label="Custom icons" caption="leftIcon/rightIcon override the default volume glyphs; showValue hidden">
        <div className="w-80">
          <ElasticSlider
            defaultValue={70}
            leftIcon={<Sun className="size-5" aria-hidden="true" />}
            rightIcon={<Moon className="size-5" aria-hidden="true" />}
            showValue={false}
          />
        </div>
      </VariantBlock>

      <VariantBlock label="Stepped" caption="step=10">
        <div className="w-80">
          <ElasticSlider defaultValue={40} step={10} max={100} />
        </div>
      </VariantBlock>

      <VariantBlock label="Disabled">
        <div className="w-80">
          <ElasticSlider defaultValue={50} disabled />
        </div>
      </VariantBlock>
    </Section>
  );
}
